import React, {
    PropsWithChildren,
    RefObject,
    useImperativeHandle,
    useRef
} from "react";

interface Props extends PropsWithChildren {
    onLoadMore?: () => void;
    ref?: RefObject<any>;
    isLoading?: boolean;
    className?: string;
}

export function InfinityListComponent({
    onLoadMore,
    ref,
    isLoading,
    className,
    children
}: Props) {
    window.onscroll = onScroll;

    function onScroll() {
        if (
            window.innerHeight + window.scrollY >=
                document.body.offsetHeight - 2 &&
            !isLoading &&
            onLoadMore
        ) {
            onLoadMore();
        }
    }

    useImperativeHandle(ref, () => ({
        reset() {
            if (scrollRef.current) {
                scrollRef.current.scrollTop = 0;
            }
        }
    }));

    const scrollRef = useRef<HTMLDivElement>(null);

    return (
        <div ref={ref} className={`h-[inherit] relative ${className ?? ""}`}>
            <div ref={scrollRef} className={"h-[inherit]"}>
                {children}
            </div>
            {children && isLoading && (
                <div
                    className={
                        "flex h-[150px] absolute w-full justify-center animate-fade-in-fast bg-gradient-to-t from-system-white to-transparent to-100% from-40% bottom-0 pt-[100px]"
                    }
                >
                    <p className="text-n font-normal text-extra-placeholder-text">
                        Henter...
                    </p>
                </div>
            )}
            {!children && isLoading && (
                <div
                    className={
                        "flex bg-loadingTransparent absolute w-full bottom-0 h-full items-center justify-center animate-fade-in-fast"
                    }
                >
                    <p className="text-n font-normal text-extra-placeholder-text">
                        Henter...
                    </p>
                </div>
            )}
        </div>
    );
}
